export const orderLogAddress = {
  numberType: { zh: '单号类型', en: 'Number type', pu: 'Tipo de número' },
  result: { zh: '邮编校验结果', en: 'CEP validation result', pu: 'Validação por CEP' },
  NOT_CHECKED: { zh: '未校验', en: 'Not checked', pu: 'Não verificado' },
  UNCHANGED: { zh: '未变化', en: 'Unchanged', pu: 'Sem alteração' },
  NORMALIZED: { zh: '仅格式规范化', en: 'Normalized only', pu: 'Somente normalização' },
  CORRECTED: { zh: '已纠正', en: 'Corrected', pu: 'Corrigido' },
  NO_RESULT: { zh: '未返回结果', en: 'No result', pu: 'Sem resultado' },
  LOOKUP_FAILED: { zh: '查询异常', en: 'Lookup failed', pu: 'Falha na consulta' },
  unrecorded: { zh: '未记录', en: 'Not recorded', pu: 'Não registrado' },
  unknown: { zh: '未知结果', en: 'Unknown result', pu: 'Resultado desconhecido' },
  hint: {
    zh: '新结果仅覆盖发布后记录；查询及日志时间为巴西时间，支持近180天、单次31天。',
    en: 'New results cover records after release. Brazil time, last 180 days, up to 31 days per query.',
    pu: 'Novos resultados abrangem registros após a publicação. Horário do Brasil: últimos 180 dias, até 31 dias por consulta.'
  },
  before: { zh: '校验前收件地址', en: 'Before validation', pu: 'Endereço antes da validação' },
  after: { zh: '校验后收件地址', en: 'After validation', pu: 'Endereço após a validação' },
  loggedAddress: { zh: '日志中的收件地址', en: 'Address recorded in log', pu: 'Endereço registrado no log' },
  comparison: { zh: '收件地址对照', en: 'Recipient address comparison', pu: 'Comparação do destinatário' },
  correctionNote: {
    zh: '按邮编覆盖后州或城市发生变化，不等于认定客户地理地址填写错误。',
    en: 'A change after CEP lookup does not prove the geographic address was incorrect.',
    pu: 'Uma alteração após a consulta por CEP não comprova que o endereço geográfico estava errado.'
  },
  legacyNote: {
    zh: '历史日志没有可靠校验结果或原地址快照，无法判定是否曾被纠正。',
    en: 'The historical log has no reliable validation result or original address snapshot.',
    pu: 'O log histórico não possui resultado confiável nem captura do endereço original.'
  },
  UNCHANGED_note: {
    zh: '邮编查询有结果，覆盖后的州和城市与原值完全一致。',
    en: 'The CEP lookup returned a result. State and city are unchanged.',
    pu: 'A consulta por CEP retornou resultado. O estado e a cidade não foram alterados.'
  },
  NORMALIZED_note: {
    zh: '仅首尾空格、大小写或重音等格式不同，规范化后州和城市一致。',
    en: 'Only trimming, case or accents differ. Normalized state and city match.',
    pu: 'Há apenas diferenças de espaços nas extremidades, letras ou acentos. Após normalização, estado e cidade coincidem.'
  },
  NOT_CHECKED_note: {
    zh: '本次请求未执行收件邮编查询，无法据此判定地址是否被纠正。',
    en: 'This request did not perform the recipient CEP lookup.',
    pu: 'Esta solicitação não consultou o CEP do destinatário.'
  },
  NO_RESULT_note: {
    zh: '邮编查询未返回结果，可能是无数据、数据不完整或服务不可用。',
    en: 'No result was returned. Data may be missing, incomplete or the service unavailable.',
    pu: 'A consulta não retornou resultado. Os dados podem estar ausentes, incompletos ou o serviço indisponível.'
  },
  LOOKUP_FAILED_note: {
    zh: '本次收件邮编查询发生可观测异常，日志中的地址不代表校验成功。',
    en: 'The recipient CEP lookup failed. The logged address does not indicate successful validation.',
    pu: 'A consulta do CEP falhou. O endereço no log não indica uma validação bem-sucedida.'
  },
  unknownNote: {
    zh: '当前版本无法识别此校验结果，请核对服务端版本。',
    en: 'This validation result is not recognized by the current version.',
    pu: 'Este resultado não é reconhecido pela versão atual.'
  },
  empty: {
    zh: '未找到符合条件的日志；历史未记录日志不会命中具体校验结果。',
    en: 'No matching logs. Historical logs without a result do not match a specific validation result.',
    pu: 'Nenhum log encontrado. Logs históricos sem resultado não correspondem a um resultado específico.'
  },
  queryFailed: { zh: '查询失败，请重试', en: 'Query failed. Please retry.', pu: 'Falha na consulta. Tente novamente.' },
  exportFailed: { zh: '导出失败，请重试', en: 'Export failed. Please retry.', pu: 'Falha na exportação. Tente novamente.' },
  brazilTime: { zh: '巴西时间', en: 'Brazil time', pu: 'Horário do Brasil' },
  invalidTime: { zh: '请提供完整有效的时间范围', en: 'Provide two valid dates', pu: 'Informe as duas datas válidas' },
  reversedTime: { zh: '开始时间不能晚于结束时间', en: 'Start time must not be after end time', pu: 'A data inicial deve ser anterior à final' },
  futureStart: { zh: '开始时间不能位于未来', en: 'Start time cannot be in the future', pu: 'A data inicial não pode estar no futuro' },
  max31Days: { zh: '单次查询跨度不能超过31天', en: 'Maximum query range is 31 days', pu: 'O intervalo máximo é de 31 dias' },
  max180Days: { zh: '仅支持查询近180天', en: 'Only the last 180 days are searchable', pu: 'Consulte apenas os últimos 180 dias' },
  maxNumbers: { zh: '最多查询200个单号', en: 'Maximum 200 numbers', pu: 'Máximo de 200 números' }
};
